import moment from 'moment-timezone';
import { MomentInput } from 'moment';

export const PARIS_TIMEZONE = 'Europe/Paris';

const hasTimezoneOffset = (date: string) =>
  /(?:Z|[+-]\d{2}:?\d{2})$/i.test(date);

export const momentTimezone = (
  date?: MomentInput,
  timezone = PARIS_TIMEZONE,
) =>
  typeof date === 'string' && date && !hasTimezoneOffset(date)
    ? moment.tz(date, timezone)
    : moment(date).tz(timezone);

export const getCalendarSlot = (
  day: MomentInput,
  hour: number,
  minute = 0,
) =>
  momentTimezone(day).set({
    hour,
    minute,
    second: 0,
    millisecond: 0,
  });
